import React from 'react';
import { Helmet } from 'react-helmet';
import { Card, Container } from 'react-bootstrap';

function NotFound() {
  return (
    <>
      <Helmet>
        <title>Page Not Found</title>
      </Helmet>

      <Container fluid>
        <Card>
          <Card.Header>
            <h4 className="card-header-title">Sivua ei löytynyt.</h4>
          </Card.Header>
        </Card>
      </Container>
    </>
  );
}

export default NotFound;
